import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=71354d23&scoped=true"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"
import style0 from "./Users.vue?vue&type=style&index=0&id=71354d23&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71354d23",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71354d23')) {
      api.createRecord('71354d23', component.options)
    } else {
      api.reload('71354d23', component.options)
    }
    module.hot.accept("./Users.vue?vue&type=template&id=71354d23&scoped=true", function () {
      api.rerender('71354d23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Search/Tabs/Users.vue"
export default component.exports